import { render } from "./InputDiagnosis.vue?vue&type=template&id=2772d863"
import script from "./InputDiagnosis.vue?vue&type=script&lang=js"
export * from "./InputDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__